import dayjs from 'dayjs';
import { useReduxDispatch, useReduxSelector } from '../../../Store/reduxHooks';
import { markSelectedMessagesAsRead } from '../../../Store/reducers/RegisteredUsers';
import { STRINGS } from '../../../Constants/ConstantStrings';
import { RootState } from '../../../store';
import { ContactHistoryStyles } from './styles';
import { getPermission } from '../../../CommonUtilities/CommonUtilities';
import { CSSProperties, useEffect, useRef, useState } from 'react';
import PALoader from '../../../SharedComponets/PALoader';
import { PopupWindowContainer } from '../../../SharedComponets/PopupWindow';

export const ContactHistory = (props: any) => {
  const isFetchingChatHistory = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.isFetchingChatHistory
    ),
    currentUser = useReduxSelector(
      (State: RootState) => State.Common.currentUserDetails
    ),
    closuresUnreadMessagesCount = useReduxSelector(
      (state: RootState) => state.Closures.closuresUnreadMessagesCount
    ),
    selectedClosure = useReduxSelector(
      (state: RootState) => state.Common.selectedClosure
    ),
    dispatch = useReduxDispatch();

  const popUpRef = useRef<HTMLDivElement>(null);

  const [customStyles, setCustomStyles] = useState<CSSProperties>({
    zIndex: 2,
    position: 'fixed',
    right: props.viewWidth + 30,
    top: props.topVal,
    minWidth: 300,
    maxWidth: 400
  });

  const Popup = document.getElementById('contact-history-popup');
  Popup?.addEventListener('wheel', (e) => {
    e.stopPropagation();
  });

  useEffect(() => {
    if (popUpRef && popUpRef.current) {
      const rect = popUpRef.current.getBoundingClientRect();

      if (window.innerHeight < rect.bottom) {
        setCustomStyles((prevStyles) => ({
          ...prevStyles,
          /* /2 - As innerHeight is less that the bottomHeight we are making to rendering the popup in the middle of View height. */
          top: props.topVal - rect.height / 2 + props.viewHeight
        }));
      } else {
        setCustomStyles((prevStyles) => ({
          ...prevStyles,
          /* /4 - As innerHeight is greater than the bottomHeight we are rendering the popup in the 1/4 height of  view height. */
          top: props.topVal - (rect.height / 4 - props.viewHeight)
        }));
      }
    }
  }, [popUpRef, props.topVal]);

  return (
    <>
      <PopupWindowContainer
        style={customStyles}
        id="contact-history-popup"
        dataTestId="contact-history-popup"
        ref={popUpRef}
        title={STRINGS.CONTACT_HISTORY}
        onClose={() => {
          props.onPopupClose();
          props.ContactHistoryPopup();
        }}
      >
        {isFetchingChatHistory ? (
          <PALoader />
        ) : (
          <ContactHistoryStyles className="d-flex flex-column gap-3 overflow-auto">
            <div
              className="contact-details"
              data-testid="contact-phone-number"
              tabIndex={0}
              aria-label={`${STRINGS.PHONE} : ${props.selectedUser.phone_number}`}
            >
              <h6 aria-hidden="true">{STRINGS.PHONE}</h6>
              <p className="white-space-wrap">
                {props.selectedUser.phone_number}
              </p>
            </div>
            {props.chatHistory &&
              props.chatHistory.map((message: any) => {
                return (
                  <div
                    className={`${
                      message.sent_by ? 'my-messages' : 'incoming-messages'
                    } d-flex flex-column gap-1`}
                    data-testid="message-container"
                  >
                    <section
                      aria-label={
                        `Message ${message.sent_by ? 'sent' : 'received'} on ` +
                        `${dayjs(message.created).format(
                          'MM/DD/YYYY hh:mm A'
                        )} ` +
                        `with message body: ${message.message_body}` +
                        `${
                          message.read_by?.email
                            ? ` read by ${message.read_by?.email}`
                            : ''
                        }`
                      }
                      tabIndex={0}
                      className={
                        !message.sent_by && message.is_read
                          ? 'read-msg'
                          : 'unread-msg'
                      }
                      data-testid="message-body"
                    >
                      <span aria-hidden="true">{message.message_body}</span>
                    </section>
                    <div
                      className={`${
                        message.sent_by
                          ? 'justify-content-end'
                          : 'justify-content-between'
                      } d-flex`}
                    >
                      <span className="message-date-time" aria-hidden="true">
                        {dayjs(message.created).format('MM/DD/YYYY hh:mm A')}
                      </span>
                      {!message.sent_by ? (
                        !message.is_read ? (
                          getPermission(
                            currentUser,
                            'update_messages_states'
                          ) && (
                            <span
                              onClick={() =>
                                dispatch(
                                  markSelectedMessagesAsRead({
                                    messageIds: [message.id],
                                    userId: props.selectedUser.id,
                                    closureUnreadMessagesCount:
                                      closuresUnreadMessagesCount,
                                    closureId: selectedClosure.id,
                                    searchField: props.searchField
                                  })
                                )
                              }
                              tabIndex={0}
                              role="button"
                              aria-label={`Mark message ${message.message_body} as read`}
                              className="mark-as-read-text"
                            >
                              {STRINGS.MARK_AS_READ}
                            </span>
                          )
                        ) : (
                          <span className="user-name" aria-hidden="true">
                            {message.read_by?.email}
                          </span>
                        )
                      ) : null}
                    </div>
                  </div>
                );
              })}
          </ContactHistoryStyles>
        )}
      </PopupWindowContainer>
    </>
  );
};

export default ContactHistory;
